import svg from './row-svg/geoportail-v2.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function GeoportailV2Icon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default GeoportailV2Icon;
